module.exports = __webpack_public_path__ + "img/Superb_sword_13.9d2556c3.png";